var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06652 0.666642C9.06652 0.353681 8.81281 0.0999756 8.49985 0.0999756C8.18689 0.0999756 7.93319 0.353681 7.93319 0.666642V9.33331C7.93319 9.64627 8.18689 9.89998 8.49985 9.89998C8.81281 9.89998 9.06652 9.64627 9.06652 9.33331V0.666642Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 9.99998C3.1665 7.51486 4.8662 5.42672 7.1665 4.83467V6.01603C5.5005 6.57336 4.29984 8.14645 4.29984 9.99998C4.29984 12.3196 6.18024 14.2 8.49984 14.2C10.8194 14.2 12.6998 12.3196 12.6998 9.99998C12.6998 8.14645 11.4992 6.57336 9.83317 6.01603V4.83467C12.1335 5.42672 13.8332 7.51486 13.8332 9.99998C13.8332 12.9455 11.4454 15.3333 8.49984 15.3333C5.55432 15.3333 3.1665 12.9455 3.1665 9.99998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpe);
export default __webpack_public_path__ + "static/media/CPE.88b71852c6c08e36b35019fbdc00f6d8.svg";
export { ForwardRef as ReactComponent };